(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('PlanDeEstudiosDeleteController',PlanDeEstudiosDeleteController);

    PlanDeEstudiosDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlanDeEstudios'];

    function PlanDeEstudiosDeleteController($uibModalInstance, entity, PlanDeEstudios) {
        var vm = this;

        vm.planDeEstudios = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PlanDeEstudios.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
